const initialState = {
    levelTwoList: [],
    isFetchingLevelTwo: false,
    isAddingLevelTwo: false,
    isFetchingLevelTwoWithLevelOneId: false,
    levelTwoWithLevelOneIdList: [],
};

const LevelTwoReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_ADD_LEVELTWO":
            return { ...state, isAddingLevelTwo: true };
        case "SUCCESS_ADD_LEVELTWO":
            return { ...state, levelTwoList: action.payload, isAddingLevelTwo: false };
        case "ERROR_ADD_LEVELTWO":
            return { ...state };


        case "REQUEST_GET_LEVELTWO":
            return { ...state, isFetchingLevelTwo: true };
        case "SUCCESS_GET_LEVELTWO":
            return { ...state, levelTwoList: action.payload, isFetchingLevelTwo: false };
        case "ERROR_GET_LEVELTWO":
            return { ...state, isFetchingLevelTwo: false };


        case "REQUEST_GET_LEVELTWO_WITH_LEVELONE_ID":
            return { ...state, isFetchingLevelTwoWithLevelOneId: true };
        case "SUCCESS_GET_LEVELTWO_WITH_LEVELONE_ID":
            return { ...state, levelTwoWithLevelOneIdList: action.payload, isFetchingLevelTwoWithLevelOneId: false };
        case "ERROR_GET_LEVELTWO_WITH_LEVELONE_ID":
            return { ...state, isFetchingLevelTwoWithLevelOneId: false };


        default:
            return state;
    }
};
export default LevelTwoReducer;